//
// GridColumnInfoManager.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";

var GridColumnInfoManager = createModule("commons::GridColumnInfoManager", [], EventDispatcher, [
    {
        CONTENT_CHANGED: 20043,
    },
    ,
    ,
    ,
    ,
    ,
    ,
]);
export default GridColumnInfoManager;
